
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignFoundationsIconography',
  components: { DesignContentLayout }
};
